import React from 'react';
import { FormModalContainer, FormModalContent, CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import AddClassForm from '../../forms/AddClassForm';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { ClassesActionCreators } from '../../../../Store/ActionCreators/ClassesActionCreators';

let AddClassModal = ({ closeModal, onClose, onSave, isEdit, ...props }) => {
    return (
        <FormModalContainer>
            <FormModalContent>
                <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                    {isEdit ? (props.series ? 'Edit Series' : 'Edit Class') : 'Add Class'}
                </Text>

                <CloseIconContainer onClick={closeModal}>
                    <i className="fas fa-times" />
                </CloseIconContainer>

                <AddClassForm {...props} isEdit={isEdit} closeModal={closeModal} />
            </FormModalContent>
        </FormModalContainer>
    );
};

const mapDispatchToProps = dispatch => ({
    clearClassErrors: () => dispatch(ClassesActionCreators.clearClassErrors()),
});

AddClassModal = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    withHandlers({
        closeModal: ({ onClose, clearClassErrors }) => () => {
            onClose();
            clearClassErrors();
        },
    }),
)(AddClassModal);

export { AddClassModal };



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddClassModal/AddClassModal.js